"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
var React = __importStar(require("react"));
var Checkbox_1 = __importDefault(require("../../Checkbox"));
var Icon_1 = __importDefault(require("../../Icon"));
var styled_components_1 = __importStar(require("../../Themes/styled-components"));
var Label_1 = __importDefault(require("../components/Label"));
var Option = styled_components_1.default('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: ", ";\n  display: flex;\n  width: 100%;\n  position: relative;\n  align-content: center;\n  align-items: center;\n  min-height: ", ";\n  flex-shrink: 0;\n  padding: 0 ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  background-color: #fff;\n  ", ";\n  ", ";\n"], ["\n  font-size: ", ";\n  display: flex;\n  width: 100%;\n  position: relative;\n  align-content: center;\n  align-items: center;\n  min-height: ", ";\n  flex-shrink: 0;\n  padding: 0 ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  background-color: #fff;\n  ",
    ";\n  ",
    ";\n"])), polished_1.em(14), polished_1.em(32), function (_a) {
    var theme = _a.theme;
    return polished_1.em(theme.grid.gutterWidth);
}, function (_a) {
    var focused = _a.focused, theme = _a.theme;
    return focused && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: ", ";\n      color: ", ";\n    "], ["\n      background-color: ", ";\n      color: ", ";\n    "])), theme.color.primaryBg, theme.color.primary);
}, function (_a) {
    var highlighted = _a.highlighted, theme = _a.theme;
    return highlighted && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      cursor: default;\n      background-color: ", " !important;\n      color: #fff !important;\n    "], ["\n      cursor: default;\n      background-color: ", " !important;\n      color: #fff !important;\n    "])), theme.color.primary);
});
var InteractableOption = styled_components_1.default(Option)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  cursor: pointer;\n  :hover {\n    background-color: ", ";\n    color: ", ";\n  }\n  :active {\n    background-color: ", ";\n    color: ", ";\n  }\n"], ["\n  cursor: pointer;\n  :hover {\n    background-color: ", ";\n    color: ", ";\n  }\n  :active {\n    background-color: ", ";\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.primaryBg;
}, function (_a) {
    var theme = _a.theme;
    return theme.color.primary;
}, function (_a) {
    var theme = _a.theme;
    return polished_1.darken(0.05, theme.color.primaryBg);
}, function (_a) {
    var theme = _a.theme;
    return theme.color.primary;
});
var ReturnIcon = styled_components_1.default(Icon_1.default)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-left: auto;\n  padding-left: ", ";\n  min-width: 24px;\n"], ["\n  margin-left: auto;\n  padding-left: ", ";\n  min-width: 24px;\n"])), function (_a) {
    var theme = _a.theme;
    return polished_1.em(theme.grid.gutterWidth);
});
exports.default = React.forwardRef(function (props, ref) {
    var option = props.option, onSelectOption = props.onSelectOption, _a = props.selected, selected = _a === void 0 ? false : _a, _b = props.focused, focused = _b === void 0 ? false : _b, _c = props.useCheckbox, useCheckbox = _c === void 0 ? false : _c, _d = props.iconSize, iconSize = _d === void 0 ? 14 : _d, renderLabel = props.renderLabel, idx = props.idx, restProps = __rest(props, ["option", "onSelectOption", "selected", "focused", "useCheckbox", "iconSize", "renderLabel", "idx"]);
    function handleMouseDown(e) {
        e.stopPropagation();
        e.preventDefault();
    }
    function handleClick(e) {
        e.stopPropagation();
        e.preventDefault();
        if (onSelectOption) {
            onSelectOption(option);
        }
    }
    var content = (React.createElement(React.Fragment, null,
        useCheckbox && React.createElement(Checkbox_1.default, { checked: selected, readOnly: true }),
        React.createElement(Label_1.default, { label: typeof renderLabel !== 'undefined'
                ? renderLabel(option, idx)
                : option.label, icon: option.icon, iconSize: iconSize, iconColor: !useCheckbox && selected ? '#fff' : undefined }),
        focused && (React.createElement(ReturnIcon, { color: !useCheckbox && selected ? '#fff' : undefined, name: "return" }))));
    var commonProps = __assign({ selected: selected,
        focused: focused, highlighted: !useCheckbox && selected, ref: ref, onMouseDown: handleMouseDown }, restProps);
    return onSelectOption ? (React.createElement(InteractableOption, __assign({ onClick: handleClick }, commonProps), content)) : (React.createElement(Option, __assign({}, commonProps), content));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
